<!-- 个人信息 -->
<template>
  <div class="personal">
    <div class="title">
      <h2 class="fl">个人信息</h2>
      <button class="fr upload-btn" @click="onEdit">
        编辑
      </button>
    </div>
    <div class="personal-information">
      <div class="top">
        <div class="fl" v-if="dataList.avatar != null && dataList.avatar != ''">
          <img :src="dataList.avatar" alt="头像" />
        </div>
        <div class="fl" v-else>
          <img src="./../assets/200.png" alt="头像" />
        </div>
        <div class="fr top-main">
          <div class="fl items">
            <ul>
              <li>
                <span class="lable">姓名：</span>
                <span class="text1">{{ dataList.name || "未知" }}</span>
              </li>
              <li>
                <span class="lable">出生年月：</span>
                <span class="text1">{{ dataList.birthday | dateFormat2 }}</span>
              </li>
              <li>
                <span class="lable">性别：</span>
                <span class="text1">{{ dataList.sex == 1 ? "男" : "女" }}</span>
              </li>
              <li>
                <span class="lable">民族：</span>
                <span class="text1">{{ dataList.race || "未知" }}</span>
              </li>
              <li>
                <span class="lable">政治面貌：</span>
                <span class="text1">{{
                  dataList.political_features || "未知"
                }}</span>
              </li>
            </ul>
          </div>
          <div class="fl items">
            <ul>
              <li>
                <span class="lable">学号：</span>
                <span class="text1">{{ dataList.studentsn || "未知" }}</span>
              </li>
              <li>
                <span class="lable">手机：</span>
                <span class="text1">{{ dataList.mobile || "未知" }}</span>
              </li>
              <li>
                <span class="lable">固定电话：</span>
                <span class="text1">{{ dataList.phone || "未知" }}</span>
              </li>
              <li>
                <span class="lable">文化程度：</span>
                <span class="text1">{{
                  dataList.educational_level || "未知"
                }}</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="center">
        <div class="fl items">
          <ul>
            <li>
              <span class="lable">通讯地址：</span>
              <span class="text1">{{ dataList.address || "未知" }}</span>
            </li>
            <li>
              <span class="lable">邮政编码：</span>
              <span class="text1">{{ dataList.postcode || "未知" }}</span>
            </li>
            <li>
              <span class="lable">工作单位：</span>
              <span class="text1">{{ dataList.work_unit || "未知" }}</span>
            </li>
            <li>
              <span class="lable">工作年月：</span>
              <span class="text1">{{ dataList.work_date || "未知" }}</span>
            </li>
            <li>
              <span class="lable">毕业学校：</span>
              <span class="text1">{{ dataList.finish_school || "未知" }}</span>
            </li>
            <li>
              <span class="lable">毕业时间：</span>
              <span class="text1">{{
                dataList.finish_school_date || "未知"
              }}</span>
            </li>
          </ul>
        </div>
        <div class="fl items">
          <ul>
            <li>
              <span class="lable">报考类别：</span>
              <span class="text1">{{
                sendType1(dataList.exam_type) || "未知"
              }}</span>
            </li>
            <li>
              <span class="lable">应试语种：</span>
              <span class="text1">{{
                sendType2(dataList.exam_language) || "未知"
              }}</span>
            </li>
            <li>
              <span class="lable">录取学校：</span>
              <span class="text1">{{
                dataList.exam_school || "未知"
              }}</span>
            </li>
            <li>
              <span class="lable">录取专业：</span>
              <span class="text1">{{
                dataList.exam_subject || "未知"
              }}</span>
            </li>
            <li>
              <span class="lable">入学时间：</span>
              <span class="text1">{{ dataList.add_time || "未知" }}</span>
            </li>
            <li>
              <span class="lable">计划结业时间：</span>
              <span class="text1">{{
                dataList.plan_complete_time || "未知"
              }}</span>
            </li>
          </ul>
        </div>
      </div>
      <div class="bottom">
        <h4>缴费记录:</h4>
        <div class="list">
          <div class="list-title">
            <span>缴费科目</span>
            <span>缴费金额</span>
            <span>缴费时间</span>
            <span>支付方式</span>
          </div>
          <div
            class="list-main"
            v-for="(item, index) in dataList2"
            :key="index"
          >
            <span>{{ item.name }}</span>
            <span>{{ item.money }}</span>
            <span>{{ item.charge_time | dateFormat }}</span>
            <span>{{ sendType(item.pay_type) }}</span>
          </div>
        </div>
      </div>
    </div>
    <el-dialog
      title="编辑"
      :visible.sync="centerDialogVisible"
      width="760px"
      center
      class="dialog6"
    >
      <div class="concent1">
        <el-form ref="form" :model="form" label-width="110px">
          <el-form-item label="姓名:">
            <el-input v-model="form.name" placeholder="请输入姓名"></el-input>
          </el-form-item>
          <el-form-item label="入学时间:">
            <el-input
              v-model="form.add_time"
              placeholder="请输入入学时间"
            ></el-input>
          </el-form-item>
          <el-form-item label="报考类别:">
            <el-select
              v-model="form.exam_type"
              placeholder="请选择报考类别"
              style="width: 100%;"
            >
              <el-option label="业余" value="1"></el-option>
              <el-option label="函授" value="2"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="出生日期:">
            <el-date-picker
              type="date"
              placeholder="请选择出生日期"
              v-model="form.birthday"
              value-format="timestamp"
              style="width: 100%;"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="固定号码:">
            <el-input
              v-model="form.phone"
              placeholder="请输入固定号码"
            ></el-input>
          </el-form-item>
          <el-form-item label="性别:">
            <el-select
              v-model="form.sex"
              placeholder="请选择性别"
              style="width: 100%;"
            >
              <el-option label="男" value="1"></el-option>
              <el-option label="女" value="2"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="文化程度:">
            <el-input
              v-model="form.educational_level"
              placeholder="请输入文化程度"
            ></el-input>
          </el-form-item>
          <el-form-item label="民族:">
            <el-select
              v-model="form.race"
              placeholder="请选择民族"
              style="width:100%"
            >
              <el-option
                :label="item.name"
                :value="item.id"
                v-for="(item, index) in reacList"
                :key="index"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="政治面貌:">
            <el-input
              v-model="form.political_features"
              placeholder="输入政治面貌"
            ></el-input>
          </el-form-item>
          <el-form-item label="通讯地址:">
            <el-input
              v-model="form.address"
              placeholder="选择通讯地址"
            ></el-input>
          </el-form-item>
          <el-form-item label="邮编:">
            <el-input
              v-model="form.postcode"
              placeholder="请输入邮编"
            ></el-input>
          </el-form-item>

          <el-form-item label="应试语种:">
            <el-select
              v-model="form.exam_language"
              placeholder="请选择应试语种"
              style="width:100%"
            >
              <el-option label="英语" value="1"></el-option>
              <el-option label="日语" value="2"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="工作单位:">
            <el-input
              v-model="form.work_unit"
              placeholder="请输入工作单位"
            ></el-input>
          </el-form-item>
          <el-form-item label="工作时间">
            <el-date-picker
              type="date"
              placeholder="请选择工作时间"
              v-model="form.work_date"
              value-format="timestamp"
              style="width: 100%;"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="毕业学校:">
            <el-input
              v-model="form.finish_school"
              placeholder="请选择毕业学校"
            ></el-input>
          </el-form-item>
          <el-form-item label="毕业时间:">
            <el-date-picker
              type="date"
              placeholder="请选择毕业时间"
              v-model="form.finish_school_date"
              value-format="timestamp"
              style="width: 100%;"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="计划结业时间:">
            <el-date-picker
              type="date"
              placeholder="请选择计划结业时间"
              value-format="timestamp"
              v-model="form.plan_complete_time"
              style="width: 100%;"
            ></el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="onSubmit">确认</el-button>
            <el-button @click="centerDialogVisible=false">取消</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import encrypt from "../utils/encrypt";
import { Message } from "element-ui";
import {
  studentUserInfo,
  getStudentChargeRecordList,
  editStudentInfo,
} from "@/api/common";

import { getRaceList } from "@/api/home";
import { getToken, getUid, setPhone, setOpid } from "@/utils/auth";
export default {
  //import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    //这里存放数据
    return {
      page: 1,
      total: 0,
      dataList: {},
      dataList2: [],
      reacList: [],
      centerDialogVisible: false,
      form: {
        name: "",
        add_time: "",
        exam_type: "",
        birthday: "",
        phone: "",
        sex: "",
        educational_level: "",
        race: "",
        political_features: "",
        address: "",
        postcode: "",
        exam_language: "",
        work_unit: "",
        work_date: "",
        finish_school: "",
        finish_school_date: "",
        plan_complete_time: "",
      },
    };
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    getRaceList() {
      getRaceList().then((response) => {
        this.reacList = response.data;
      });
    },
    onSubmit() {
      let token = getToken();
      let uid = getUid();
      let data = {
        uid: uid,
        name: this.form.name,
        add_time: this.form.add_time,
        exam_type: this.form.exam_type,
        birthday: Number(this.form.birthday) / 1000,
        phone: this.form.phone,
        sex: this.form.sex,
        educational_level: this.form.educational_level,
        race: this.form.race,
        political_features: this.form.political_features,
        address: this.form.address,
        postcode: this.form.postcode,
        exam_language: this.form.exam_language,
        work_unit: this.form.work_unit,
        work_date: Number(this.form.work_date) / 1000,
        finish_school: this.form.finish_school,
        finish_school_date: Number(this.form.finish_school_date) / 1000,
        plan_complete_time: Number(this.form.plan_complete_time) / 1000,
      };
      data = encrypt.Encrypt(JSON.stringify(data), token);
      token = encrypt.Encrypt(JSON.stringify(token), "");
      let params = {
        data: data,
        token: token,
      };
      editStudentInfo(params)
        .then((response) => {
          this.$message.success("修改成功");
          this.centerDialogVisible = false;
          this.fetchData();
          this.fetchData2();
        })
        .catch((error) => {
          Message({
            message: error.msg,
            type: "error",
            duration: 3 * 1000,
          });
        });
    },
    onEdit() {
      this.centerDialogVisible = true;
      let token = getToken();
      let uid = getUid();
      let data = {
        uid: uid,
      };
      data = encrypt.Encrypt(JSON.stringify(data), token);
      token = encrypt.Encrypt(JSON.stringify(token), "");
      let params = {
        data: data,
        token: token,
      };
      studentUserInfo(params).then((response) => {
        for (let key in response.data) {
          if (response.data[key]) {
            this.form[key] = response.data[key].toString();
          }
        }
        this.form.birthday = new Date(parseInt(this.form.birthday) * 1000);
        this.form.work_date = new Date(parseInt(this.form.work_date) * 1000);
        this.form.finish_school_date = new Date(
          parseInt(this.form.finish_school_date) * 1000
        );
        this.form.plan_complete_time = new Date(
          parseInt(this.form.plan_complete_time) * 1000
        );
      });
    },
    sendType1(val) {
      switch (val) {
        case 1:
          return "业余";
        default:
          return "函授";
          break;
      }
    },
    sendType2(val) {
      switch (val) {
        case "1":
          return "英语";
        default:    
          return "日语";
          break;
      }
    },
    sendType(val) {
      switch (val) {
        case 1:
          return "微信";
          break;
        case 2:
          return "支付宝";
          break;
        case 3:
          return "银联支付";
          break;

        default:
          return "其他";
          break;
      }
    },
    fetchData() {
      let token = getToken();
      let uid = getUid();
      let data = {
        uid: uid,
      };
      data = encrypt.Encrypt(JSON.stringify(data), token);
      token = encrypt.Encrypt(JSON.stringify(token), "");
      let params = {
        data: data,
        token: token,
      };
      studentUserInfo(params).then((response) => {
        this.dataList = response.data;
        setPhone(response.data.user);
        if (response.data.openid != null && response.data.openid != "") {
          setOpid(1);
        } else {
          setOpid(2);
        }
      });
    },
    fetchData2() {
      let token = getToken();
      let uid = getUid();
      let data = {
        uid: uid,
      };
      data = encrypt.Encrypt(JSON.stringify(data), token);
      token = encrypt.Encrypt(JSON.stringify(token), "");
      let params = {
        data: data,
        token: token,
      };
      getStudentChargeRecordList(params).then((response) => {
        this.dataList2 = response.data;
      });
    },
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
    this.getRaceList();
    this.fetchData();
    this.fetchData2();
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
};
</script>

<style lang="scss">
.dialog6 {
  .concent1 {
    padding-top: 25px;
    padding-bottom: 80px;
    padding-left: 20px;
    height: 475px;
    overflow: auto;
    .el-form-item__label {
      line-height: 3em;
    }
    .el-form-item {
      width: 80%;
    }
  }
}
</style>
<style lang="scss" scoped>
.title {
  padding-left: 37px;
  padding-right: 60px;
  height: 75px;
  line-height: 75px;
  border-bottom: 1px solid #ebebeb;
  display: flex;
  align-content: center;
  justify-content: space-between;
  h2 {
    font-size: 24px;
    color: #00468e;
  }

  .upload-btn {
    background-color: #007dc2;
    outline: none;
    color: #ffffff;
    border: none;
    border-radius: 8px;
    width: 90px;
    height: 44px;
    font-size: 16px;
    margin: auto 0;
    cursor: pointer;
  }
}
.personal-information {
  height: calc(100% - 75px);
  padding-top: 37px;
  padding-left: 37px;
  padding-right: 60px;
  @media screen and (max-width: 992px) {
    overflow: auto;
    height: 920px;
    padding-top: 37px;
    padding-left: 15px;
    padding-right: 15px;
  }
  .fl {
    float: left;
    @media screen and (max-width: 992px) {
      float: none;
      display: block;
      overflow: auto;
      display: flex;
      justify-content: center;
      align-items: center;
      img {
        margin-bottom: 30px;
        width: 150px;
        height: 150px;
      }
    }
  }
  .fr {
    float: right;
    @media screen and (max-width: 992px) {
      float: none;
      display: block;
    }
  }
  .top {
    height: 225px;
    margin-bottom: 50px;
    img {
      width: 200px;
      height: 200px;
    }
    .top-main {
      width: 600px;
      height: 100%;
      @media screen and (max-width: 992px) {
        width: 100%;
      }
    }
    @media screen and (max-width: 992px) {
      height: 580px;
    }
  }
  .center {
    height: 270px;
    @media screen and (max-width: 992px) {
      height: 530px;
    }
  }
  .items {
    width: 50%;
    @media screen and (max-width: 992px) {
      width: 100%;
      display: block;
    }
    ul {
      height: 100%;
      li {
        height: 45px;
        .lable {
          font-size: 16px;
          color: #000000;
        }
        .text1 {
          font-size: 17px;
          color: #999999;
        }
      }
    }
  }
  .bottom {
    min-height: 100px;
    h4 {
      margin-top: 20px;
      font-size: 18px;
      color: #01458e;
    }
    .list {
      margin-top: 30px;
      .list-title {
        display: grid;
        grid-template-columns: 1fr 1fr 1fr 1fr;
        grid-template-rows: 27px;
        font-size: 15px;
        color: #666666;
        border-bottom: 1px solid #d7d7d7;
        span {
          padding-left: 9px;
        }
      }
      .list-main {
        display: grid;
        grid-template-columns: 1fr 1fr 1fr 1fr;
        grid-template-rows: 43px;
        line-height: 43px;
        font-size: 15px;
        color: #999999;
        border-bottom: 1px solid #d7d7d7;
        span {
          padding-left: 9px;
        }
      }
    }
  }
}
</style>
